// spinner.service.ts
import { Injectable } from '@angular/core';
import type { Components } from '@chefami-monorepo/ui-components/types';

type HTMLChefSpinnerElement = HTMLElement & Components.ChefSpinner;

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private spinner: HTMLChefSpinnerElement | null = null;

  private getSpinner(): HTMLChefSpinnerElement | null {
    if (!this.spinner) {
      this.spinner = document.querySelector(
        'chef-spinner'
      ) as HTMLChefSpinnerElement | null;
    }
    return this.spinner;
  }

  show(description?: string) {
    this.getSpinner()?.show(description);
  }

  hide() {
    this.getSpinner()?.hide();
  }

  toggle() {
    this.getSpinner()?.toggle();
  }
}
